import React from 'react'
import { Button } from 'react-bootstrap'
import CustomModal from 'components/CustomModal/CustomModal'

const UploadOptionsModal = ({ show, onHide, domainRecord, onPublishExisting, onUploadNew }) => {
  const fullDomain = domainRecord?.subdomain
    ? `${domainRecord.subdomain}.${domainRecord.domain}`
    : `www.${domainRecord?.domain || ''}`

  return (
    <CustomModal show={show} onHide={onHide} centered size="md" enforceFocus={false} backdrop="static">
      <div className="p-4">
        <h4 className="mb-2">Add content to your custom domain</h4>
        <p className="grey mb-4">
          Choose how you want to publish to <b>{fullDomain}</b>
        </p>

        <div className="d-flex flex-column gap-2 mb-3">
          <Button variant="primary" onClick={onPublishExisting}>
            Publish existing site
          </Button>
          <Button variant="outline-primary" onClick={onUploadNew}>
            Upload new site
          </Button>
        </div>

        <Button variant="light" onClick={onHide} className="w-100">
          Cancel
        </Button>
      </div>
    </CustomModal>
  )
}

export default UploadOptionsModal
